module.exports = __webpack_public_path__ + "media/old_images/image-download-app-4a8f25ab.png";